import { FC } from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type TextInputProps = {
  control: Control<any, any>;
  name: string;
  label?: string;
  placeholder?: string;
  inputStyle: string;
  labelStyle?: string;
  controlStyle: string;
  errorStyle: string;
  isDisabled?: boolean;
  type?: 'text' | 'number';
  rules?: RegisterOptions<any, string>;
};

export const TextInput: FC<TextInputProps> = ({
  control,
  name,
  label,
  placeholder,
  inputStyle,
  labelStyle,
  controlStyle,
  errorStyle,
  rules,
  type,
  isDisabled,
}) => {
  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { value, onChange }, fieldState }) => (
          <div className={controlStyle}>
            <div style={{ position: 'relative' }}>
              {label && (
                <label htmlFor={name} className={labelStyle}>
                  {label}
                </label>
              )}
              <input
                type={type || 'text'}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                className={`${inputStyle} ${isDisabled ? 'bg-gray-100 text-gray-400' : ''}`}
                disabled={isDisabled}
              />
            </div>
            {fieldState.error && (
              <p className={errorStyle}>{fieldState.error.message}</p>
            )}
          </div>
        )}
      />
    </>
  );
};
